import {GLTERM, matchGLTERMByType} from 'ApplicationEntry/models/ProductsRiders/GLTERM/GLTERM';
import * as G from 'ApplicationEntry/models/ProductsRiders/GLTERM/GroupGLTERM';
import * as NY from 'ApplicationEntry/models/ProductsRiders/GLTERM/NewYorkGLTERM';
import * as O from 'ApplicationEntry/models/ProductsRiders/GLTERM/OrdinaryGLTERM';
import { Plan } from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import { SalaryDeductionOccupationClassInfo, SalaryDeductionOccupationClassInfoWarning, SalaryDeductionOccupationClassModel } from 'ApplicationEntry/models/ProductsRiders/SalaryDeductionOccupationClassModel';
import {Async, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum GLTERMActionType {
  CHANGE_PLAN = 'glterm/CHANGE_PLAN',
  GET_OCC_CLASS = 'glterm/GET_OCC_CLASS',
  CHANGE_OCC_CLASS = 'glterm/CHANGE_OCC_CLASS',
  // UPDATE_OCC_CLASS_VALUE = 'glterm/UPDATE_OCC_CLASS_VALUE',
  CHANGE_PREMIUM = 'glterm/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'glterm/CHANGE_CALCULATED_PREMIUM',
  CHANGE_CWA = 'glterm/CHANGE_CWA',
  CHANGE_SITUS_STATE = 'glterm/CHANGE_SITUS_STATE',
  CHANGE_TYPE = 'glterm/CHANGE_TYPE',
  CHANGE_FACE_AMT = 'glterm/CHANGE_FACE_AMT',
  CHANGE_POLICY_NUM = 'glterm/CHANGE_POLICY_NUM',
  CHANGE_PREMIUM_TYPE = 'glterm/CHANGE_PREMIUM_TYPE',
  CHANGE_PRI_INSURED = 'glterm/CHANGE_PRI_INSURED',
  CHANGE_SPOUSE_INSURED = 'glterm/CHANGE_SPOUSE_INSURED',
  CHANGE_AUTO_ISSUE_ELIGIBILTY = 'glterm/CHANGE_AUTO_ISSUE_ELIGIBILTY',
  CHANGE_REPLACEMENT = 'glterm/CHANGE_REPLACEMENT',
  CHANGE_RIDER_CODES = 'glterm/CHANGE_RIDER_CODES',
  CHANGE_RIDER_AMTS = 'glterm/CHANGE_RIDER_AMTS',
  CHANGE_COMMISSION = 'glterm/CHANGE_COMMISSION',
  CHANGE_DEATH_BENEFIT = 'glterm/CHANGE_DEATH_BENEFIT',
  CHANGE_ADB = 'glterm/CHANGE_ADB',
  CHANGE_ADB_VALUE = 'glterm/CHANGE_ADB_VALUE',
  CHANGE_SB_VOLUME = 'glterm/CHANGE_SB_VOLUME',
  CHANGE_WAIVER = 'glterm/CHANGE_WAIVER',
  CHANGE_WAVIER_VALUE = 'glterm/CHANGE_WAVIER_VALUE',
  CHANGE_STRIKE_LAYOFF = 'glterm/CHANGE_STRIKE_LAYOFF',
  CHANGE_GUAC = 'glterm/CHANGE_GUAC',
  CHANGE_CHRONIC_ILLNESS = 'glterm/CHANGE_CHRONIC_ILLNESS',
  CHANGE_PRODUCT = 'glterm/CHANGE_PRODUCT',
  CHANGE_JSTAMP = 'glterm/CHANGE_JSTAMP',
  CHANGE_PACKAGE_NAME = 'glterm/CHANGE_PACKAGE_NAME',
  GET_PACKAGE_LIST = 'glterm/GET_PACKAGE_LIST',
  CHANGE_PACKAGE_LIST = 'glterm/CHANGE_PACKAGE_LIST',
  GET_CTPLBR_VALUE = 'glterm/GET_CTPLBR_VALUE',
  GET_GTLCLTC_VALUE = 'glterm/GET_GTLCLTC_VALUE',
  GET_GTLCLTCE_VALUE = 'glterm/GET_GTLCLTCE_VALUE',
  GET_GTLCLTCR_VALUE = 'glterm/GET_GTLCLTCR_VALUE',
  GET_GTLCLTCRE_VALUE = 'glterm/GET_GTLCLTCRE_VALUE',
  RESET_SPOUSE_INSURED = 'glterm/RESET_SPOUSE_INSURED',
  CHANGE_PACKAGE_ITEM = 'glterm/CHANGE_PACKAGE_ITEM',
  CHANGE_RIDER_INFORMATION = 'glterm/CHANGE_RIDER_INFORMATION',
}

export const isGLTERMAction = (action: any): action is GLTERMAction => action.type in reverseEnum(GLTERMActionType);

export const changePlan = (plan: string) => createAction(GLTERMActionType.CHANGE_PLAN, {plan});
export const getOccClass = (caseNumber: string, plan: Plan) =>
  createAction(GLTERMActionType.GET_OCC_CLASS, {caseNumber, plan});
export const changeOccClass = (occClass: SalaryDeductionOccupationClassModel) =>
  createAction(GLTERMActionType.CHANGE_OCC_CLASS, {occClass});
// export const updateOccClassValue = (occClassValue: string) =>
//   createAction(GLTERMActionType.UPDATE_OCC_CLASS_VALUE, {occClassValue});
export const changePremium = (premium: string) => createAction(GLTERMActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(GLTERMActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(GLTERMActionType.CHANGE_CWA, {cwa});
export const changeSitusState = (state: string) => createAction(GLTERMActionType.CHANGE_SITUS_STATE, {state});
export const changeType = (type: string) => createAction(GLTERMActionType.CHANGE_TYPE, {type});
export const changeFaceAmt = (amt: string) => createAction(GLTERMActionType.CHANGE_FACE_AMT, {amt});
export const changePolicyNum = (polNumber: string) => createAction(GLTERMActionType.CHANGE_POLICY_NUM, {polNumber});
export const changePriInsured = (insured: string) => createAction(GLTERMActionType.CHANGE_PRI_INSURED, {insured});
export const changeSpouseInsured = (insured: string) => createAction(GLTERMActionType.CHANGE_SPOUSE_INSURED, {insured});
export const changePremiumType = (type: string) => createAction(GLTERMActionType.CHANGE_PREMIUM_TYPE, {type});
export const changeEligibility = (eligibility: boolean) =>
  createAction(GLTERMActionType.CHANGE_AUTO_ISSUE_ELIGIBILTY, {eligibility});
export const changeReplacement = (replacement: boolean) =>
  createAction(GLTERMActionType.CHANGE_REPLACEMENT, {replacement});
export const changeRiderCodes = (riderCode: string, index: number) =>
  createAction(GLTERMActionType.CHANGE_RIDER_CODES, {riderCode, index});
export const changeRiderAmts = (riderAmt: number, index: number) =>
  createAction(GLTERMActionType.CHANGE_RIDER_AMTS, {riderAmt, index});

export const changeCommission = (commission: string) => createAction(GLTERMActionType.CHANGE_COMMISSION, {commission});
export const changeDeathBenefit = (deathBenefit: string) =>
  createAction(GLTERMActionType.CHANGE_DEATH_BENEFIT, {deathBenefit});
export const changeSBVolume = (vol: string) => createAction(GLTERMActionType.CHANGE_SB_VOLUME, {vol});
export const changeChronicIllness = (illness: string) =>
  createAction(GLTERMActionType.CHANGE_CHRONIC_ILLNESS, {illness});

export const changeADB = (adb: boolean) => createAction(GLTERMActionType.CHANGE_ADB, {adb});
export const changeADBValue = (adbValue: string) => createAction(GLTERMActionType.CHANGE_ADB_VALUE, {adbValue});
export const changeWaiver = (waiver: boolean) => createAction(GLTERMActionType.CHANGE_WAIVER, {waiver});
export const changeWavierValue = (waiverValue: string) => createAction(GLTERMActionType.CHANGE_WAVIER_VALUE, {waiverValue});
export const changeStrikeLayoff = (layoff: boolean) => createAction(GLTERMActionType.CHANGE_STRIKE_LAYOFF, {layoff});
export const changeGUAC = (guac: boolean) => createAction(GLTERMActionType.CHANGE_GUAC, {guac});
export const changeProduct = (product: string) => createAction(GLTERMActionType.CHANGE_PRODUCT, {product});
export const changeJStamp = (stamp: boolean) => createAction(GLTERMActionType.CHANGE_JSTAMP, {stamp});
export const changePackageName = (packageName: string) =>
  createAction(GLTERMActionType.CHANGE_PACKAGE_NAME, {packageName});
export const changePackageList = (packages: Async<object[]>) =>
  createAction(GLTERMActionType.CHANGE_PACKAGE_LIST, {packages});
export const getCTPLBR = (CTPLBR: string) =>
  createAction(GLTERMActionType.GET_CTPLBR_VALUE, {CTPLBR});
export const getGTLCLTC = (GTLCLTC: string) =>
  createAction(GLTERMActionType.GET_GTLCLTC_VALUE, {GTLCLTC});
export const getGTLCLTCE = (GTLCLTCE: string) =>
  createAction(GLTERMActionType.GET_GTLCLTCE_VALUE, {GTLCLTCE});
export const getGTLCLTCR = (GTLCLTCR: string) =>
  createAction(GLTERMActionType.GET_GTLCLTCR_VALUE, {GTLCLTCR});
export const getGTLCLTCRE = (GTLCLTCRE: string) =>
  createAction(GLTERMActionType.GET_GTLCLTCRE_VALUE, {GTLCLTCRE});
export const getPackageList = (caseNumber: string, planCode: string) =>
  createAction(GLTERMActionType.GET_PACKAGE_LIST, {caseNumber, planCode});
export const resetSpouseInsured = () => createAction(GLTERMActionType.RESET_SPOUSE_INSURED);
export const changePackageItem = (packageItem: object) =>
  createAction(GLTERMActionType.CHANGE_PACKAGE_ITEM, {packageItem});
export const changeRiderInformation = (amount: number, code: string, index: number) =>
  createAction(GLTERMActionType.CHANGE_RIDER_INFORMATION, {amount, code, index});

export type GLTERMAction =
  | ReturnType<typeof changePlan>
  | ReturnType<typeof getOccClass>
  | ReturnType<typeof changeOccClass>
  // | ReturnType<typeof updateOccClassValue>
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeSitusState>
  | ReturnType<typeof changeType>
  | ReturnType<typeof changeFaceAmt>
  | ReturnType<typeof changePolicyNum>
  | ReturnType<typeof changePriInsured>
  | ReturnType<typeof changeSpouseInsured>
  | ReturnType<typeof changePremiumType>
  | ReturnType<typeof changeEligibility>
  | ReturnType<typeof changeReplacement>
  | ReturnType<typeof changeRiderCodes>
  | ReturnType<typeof changeRiderAmts>
  | ReturnType<typeof changeCommission>
  | ReturnType<typeof changeDeathBenefit>
  | ReturnType<typeof changeSBVolume>
  | ReturnType<typeof changeChronicIllness>
  | ReturnType<typeof changeADB>
  | ReturnType<typeof changeADBValue>
  | ReturnType<typeof changeWaiver>
  | ReturnType<typeof changeWavierValue>
  | ReturnType<typeof changeStrikeLayoff>
  | ReturnType<typeof changeGUAC>
  | ReturnType<typeof changeProduct>
  | ReturnType<typeof changeJStamp>
  | ReturnType<typeof changePackageName>
  | ReturnType<typeof changePackageList>
  | ReturnType<typeof getPackageList>
  | ReturnType<typeof getCTPLBR>
  | ReturnType<typeof getGTLCLTC>
  | ReturnType<typeof getGTLCLTCE>
  | ReturnType<typeof getGTLCLTCR>
  | ReturnType<typeof getGTLCLTCRE>
  | ReturnType<typeof resetSpouseInsured>
  | ReturnType<typeof changePackageItem>
  | ReturnType<typeof changeRiderInformation>;

type GLTERMState = GLTERM;

export default (state: GLTERMState, action: GLTERMAction): GLTERMState => {
  switch (action.type) {
    case GLTERMActionType.CHANGE_PLAN:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changePlan(action.payload.plan),
        Group: G.changePlan(action.payload.plan),
        NewYork: NY.changePlan(action.payload.plan),
      })(state);
    case GLTERMActionType.GET_OCC_CLASS:
      return matchGLTERMByType<GLTERM>({
        Group: G.changeOccClass(new Loading()),
        _: () => state,
      })(state);
    case GLTERMActionType.CHANGE_OCC_CLASS:
      return matchGLTERMByType<GLTERM>({
        Group: G.changeOccClass(action.payload.occClass),
        _: () => state,
      })(state);
    // case GLTERMActionType.UPDATE_OCC_CLASS_VALUE:
    //   return matchGLTERMByType<GLTERM>({
    //     Group: G.updateOccClassValue(action.payload.occClassValue),
    //     _: () => state,
    //   })(state);
    case GLTERMActionType.CHANGE_PREMIUM:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changePremium(action.payload.premium),
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
      })(state);
    case GLTERMActionType.CHANGE_CALCULATED_PREMIUM:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeCalculatedPremium(action.payload.calculatedPremium),
        Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
        NewYork: NY.changeCalculatedPremium(action.payload.calculatedPremium),
      })(state);
    case GLTERMActionType.CHANGE_CWA:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeCWA(action.payload.cwa),
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
      })(state);
    case GLTERMActionType.CHANGE_SITUS_STATE:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeSitusState(action.payload.state),
        Group: G.changeSitusState(action.payload.state),
        NewYork: NY.changeSitusState(action.payload.state),
      })(state);
    case GLTERMActionType.CHANGE_TYPE:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeType(action.payload.type),
        Group: G.changeType(action.payload.type),
        NewYork: NY.changeType(action.payload.type),
      })(state);
    case GLTERMActionType.CHANGE_FACE_AMT:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeFaceAmt(action.payload.amt),
        Group: G.changeFaceAmt(action.payload.amt),
        NewYork: NY.changeFaceAmt(action.payload.amt),
      })(state);
    case GLTERMActionType.CHANGE_POLICY_NUM:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changePolicyNumber(action.payload.polNumber),
        Group: G.changePolicyNumber(action.payload.polNumber),
        NewYork: NY.changePolicyNumber(action.payload.polNumber),
      })(state);
    case GLTERMActionType.CHANGE_PREMIUM_TYPE:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changePremiumType(action.payload.type),
        Group: G.changePremiumType(action.payload.type),
        NewYork: NY.changePremiumType(action.payload.type),
      })(state);
    case GLTERMActionType.CHANGE_PRI_INSURED:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changePriInsured(action.payload.insured),
        Group: G.changePriInsured(action.payload.insured),
        NewYork: NY.changePriInsured(action.payload.insured),
      })(state);
    case GLTERMActionType.CHANGE_SPOUSE_INSURED:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeSpouseInsured(action.payload.insured),
        Group: G.changeSpouseInsured(action.payload.insured),
        NewYork: NY.changeSpouseInsured(action.payload.insured),
      })(state);
    case GLTERMActionType.CHANGE_AUTO_ISSUE_ELIGIBILTY:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeAutoIssue(action.payload.eligibility),
        Group: G.changeAutoIssue(action.payload.eligibility),
        NewYork: NY.changeAutoIssue(action.payload.eligibility),
      })(state);
    case GLTERMActionType.CHANGE_REPLACEMENT:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeReplacement(action.payload.replacement),
        Group: G.changeReplacement(action.payload.replacement),
        NewYork: NY.changeReplacement(action.payload.replacement),
      })(state);
    case GLTERMActionType.CHANGE_RIDER_CODES:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeRiderCodes(action.payload.riderCode, action.payload.index),
        NewYork: NY.changeRiderCodes(action.payload.riderCode, action.payload.index),
        _: () => state,
      })(state);
    case GLTERMActionType.CHANGE_RIDER_AMTS:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeRiderAmount(action.payload.riderAmt, action.payload.index),
        NewYork: NY.changeRiderAmount(action.payload.riderAmt, action.payload.index),
        _: () => state,
      })(state);
    case GLTERMActionType.CHANGE_COMMISSION:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeCommision(action.payload.commission),
        Group: G.changeCommision(action.payload.commission),
        NewYork: NY.changeCommision(action.payload.commission),
      })(state);
    case GLTERMActionType.CHANGE_DEATH_BENEFIT:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeDeathBenefit(action.payload.deathBenefit),
        Group: G.changeDeathBenefit(action.payload.deathBenefit),
        NewYork: NY.changeDeathBenefit(action.payload.deathBenefit),
      })(state);
    case GLTERMActionType.CHANGE_SB_VOLUME:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeSBVolume(action.payload.vol),
        Group: G.changeSBVolume(action.payload.vol),
        NewYork: NY.changeSBVolume(action.payload.vol),
      })(state);
    case GLTERMActionType.CHANGE_ADB:
      return matchGLTERMByType<GLTERM>({
        Ordinary: O.changeADB(action.payload.adb),
        Group: G.changeADB(action.payload.adb),
        NewYork: NY.changeADB(action.payload.adb),
      })(state);
    case GLTERMActionType.CHANGE_ADB_VALUE:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.changeADBValue(action.payload.adbValue),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.CHANGE_WAIVER:
      return matchGLTERMByType<GLTERM>({
        Ordinary: (O.changeWaiver(action.payload.waiver)),
        Group: G.changeWaiver(action.payload.waiver),
        NewYork: NY.changeWaiver(action.payload.waiver),
      })(state);
    case GLTERMActionType.CHANGE_WAVIER_VALUE:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.changeWavierValue(action.payload.waiverValue),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.CHANGE_PRODUCT:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.changeproduct(action.payload.product),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.CHANGE_JSTAMP:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.changeJStamp(action.payload.stamp),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.CHANGE_PACKAGE_NAME:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.changePackageName(action.payload.packageName),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.GET_PACKAGE_LIST:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.changePackageList(new Loading()),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.CHANGE_PACKAGE_LIST:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.changePackageList(action.payload.packages),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.GET_CTPLBR_VALUE:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.getCTPLBR(action.payload.CTPLBR),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.GET_GTLCLTC_VALUE:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.getGTLCLTC(action.payload.GTLCLTC),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.GET_GTLCLTCE_VALUE:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.getGTLCLTCE(action.payload.GTLCLTCE),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.GET_GTLCLTCR_VALUE:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.getGTLCLTCR(action.payload.GTLCLTCR),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.GET_GTLCLTCRE_VALUE:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.getGTLCLTCRE(action.payload.GTLCLTCRE),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.RESET_SPOUSE_INSURED:
      return matchGLTERMByType<GLTERM>({
        Ordinary: () => state,
        Group: G.resetSpouseInsured(),
        NewYork: () => state,
      })(state);
    case GLTERMActionType.CHANGE_PACKAGE_ITEM:
      return matchGLTERMByType<GLTERM>({
        Group: G.changePackageItem(action.payload.packageItem),
        _: () => state,
      })(state);
    case GLTERMActionType.CHANGE_RIDER_INFORMATION:
      return matchGLTERMByType<GLTERM>({
        Group: G.changeRiderInformation(action.payload.amount, action.payload.code, action.payload.index),
        _: () => state,
      })(state);
    default:
      return state;
  }
};